module.exports = __webpack_public_path__ + "media/new-pdf-report-layout/ubezpieczenie-komunikacyjne-b6f7c4c8.png";